module.exports = __webpack_public_path__ + "static/media/zone2.67f4985f.png";